/* eslint-disable react-hooks/exhaustive-deps */
import { useFakeProgress } from 'hooks/use-fake-progress'
import { useEffect, useState } from 'react'

export function useResultsProgress() {
  const [minStep, setMinStep] = useState(8)
  const [maxStep, setMaxStep] = useState(16)
  const { progress, start, finish, isFinished } = useFakeProgress(
    minStep,
    maxStep
  )

  useEffect(() => {
    start()
  }, [])

  useEffect(() => {
    if (progress >= 60) {
      setMinStep(1)
      setMaxStep(2)
    }
  }, [progress])

  return { progress, finish, isFinished }
}
